import * as Types from '../types-api.generated';

import { UserLightFragment, MomentStatsFragment, MediaFragment, EditionSaleConfigurationFragment, DropSaleConfigurationFragment, WorldOverviewFragment } from '../api-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiWorldLaunchCollectionsVariables = Types.Exact<{
  worldId: Types.Scalars['Int'];
  page?: Types.InputMaybe<Types.Scalars['Int']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ApiWorldLaunchCollections = { exhibitionLaunchCollections: { page: number, totalPages: number, totalItems: number, items: Array<{ __typename: 'DropCollection', chainId: ChainId, contractAddress: Address, name: string, nftCount: number, slug: string, totalVolumeInEth: number, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null } | { __typename: 'EditionCollection', chainId: ChainId, contractAddress: Address, name: string, nftCount: number, slug: string, totalVolumeInEth: number, creator: { name: string | null, profileImageUrl: string | null, username: string | null, publicKey: Address }, media: { __typename: 'ImageMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, imageMimeType: Types.ApiImageMimeType } | { __typename: 'ModelMedia', processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, url: string, modelMimeType: Types.ApiModelMimeType, modelStaticUrl: string } | { __typename: 'VideoMedia', previewUrl: string | null, processingStatus: Types.ApiMediaProcessingStatus, sourceUrl: string | null, staticUrl: string | null, url: string, videoMimeType: Types.ApiVideoMimeType } | null }> } };



export const ApiWorldLaunchCollectionsDocument = /*#__PURE__*/ `
    query WorldLaunchCollections($worldId: Int!, $page: Int, $perPage: Int) {
  exhibitionLaunchCollections(
    exhibitionId: $worldId
    page: $page
    perPage: $perPage
  ) {
    items {
      __typename
      ... on LaunchCollectionInterface {
        chainId
        contractAddress
        creator {
          ...UserLightFragment
          publicKey: accountAddress
        }
        name
        nftCount
        slug
        totalVolumeInEth
        media {
          ...MediaFragment
        }
      }
    }
    page
    totalPages
    totalItems
  }
}
    ${UserLightFragment}
${MediaFragment}`;

export const useWorldLaunchCollections = <
      TData = ApiWorldLaunchCollections,
      TError = ClientError
    >(
      variables: ApiWorldLaunchCollectionsVariables,
      options?: Omit<UseQueryOptions<ApiWorldLaunchCollections, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiWorldLaunchCollections, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiWorldLaunchCollections, TError, TData>(
      {
    queryKey: ['WorldLaunchCollections', variables],
    queryFn: apiFetcher<ApiWorldLaunchCollections, ApiWorldLaunchCollectionsVariables>(ApiWorldLaunchCollectionsDocument, variables),
    ...options
  }
    )};

useWorldLaunchCollections.getKey = (variables: ApiWorldLaunchCollectionsVariables) => ['WorldLaunchCollections', variables];

export const useInfiniteWorldLaunchCollections = <
      TData = InfiniteData<ApiWorldLaunchCollections>,
      TError = ClientError
    >(
      variables: ApiWorldLaunchCollectionsVariables,
      options: Omit<UseInfiniteQueryOptions<ApiWorldLaunchCollections, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiWorldLaunchCollections, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiWorldLaunchCollections, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['WorldLaunchCollections.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiWorldLaunchCollections, ApiWorldLaunchCollectionsVariables>(ApiWorldLaunchCollectionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteWorldLaunchCollections.getKey = (variables: ApiWorldLaunchCollectionsVariables) => ['WorldLaunchCollections.infinite', variables];


useWorldLaunchCollections.fetcher = (variables: ApiWorldLaunchCollectionsVariables, options?: RequestInit['headers']) => apiFetcher<ApiWorldLaunchCollections, ApiWorldLaunchCollectionsVariables>(ApiWorldLaunchCollectionsDocument, variables, options);
